import { MDXProvider } from '@mdx-js/react';
import classnames from 'classnames';
import React, { useEffect } from 'react';

import CodeBlock from './CodeBlock/CodeBlock';
import { CodeSnippet } from './CodeSnippet/CodeSnippet';
import FetchCodeBlock from './FetchCodeBlock/FetchCodeBlock';
import './Layout.scss';
import Header from './Header/Header';
import Footer from './Footer/Footer';
import { MOBILE_OPEN } from '../utils/constants';
import { ChildrenProps } from '../entities/Children';

declare global {
  interface Window {
    data: any;
  }
}

function Title(props: ChildrenProps) {
  return <h1 className="title">{props.children}</h1>;
}

function SubTitle(props: ChildrenProps) {
  return <h1 className="subtitle">{props.children}</h1>;
}

interface ExternalLinkProps {
  children: React.ReactNode;
  href: string;
}

const ExternalLink = (props: ExternalLinkProps) => (
  <a href={props.href} target="_blank" rel="noopener noreferrer">
    {props.children}
  </a>
);

const shortcodes = {
  code: function code(props) {
    return <CodeBlock {...props} />;
  },
  inlineCode: function inlinecode(props) {
    return <CodeSnippet {...props} inline={true} theme="light" />;
  },
  pre: function pre(props) {
    return <>{props.children}</>;
  },
  /**
   * CodeBlock is a custom component that need to be insert in the Markdown;
   * - Syntax: <CodeBlock url=”https://github.com/example” className="{language}"/>
   * - FetchCodeBlock will fetch the code from the url. Broken URL show error alert;
   * - URL must be in Github domain.
   */
  CodeBlock: function CodeBlock(props) {
    return <FetchCodeBlock {...props} />;
  },
  Title,
  SubTitle,
  ExternalLink,
};

interface LayoutProps {
  children: React.ReactNode;
  className?: string;
}

export default function Layout({ children, className }: LayoutProps): React.ReactElement {
  useEffect(() => {
    localStorage.setItem(MOBILE_OPEN, null);
  }, []);
  return (
    <>
      <Header />
      <MDXProvider components={shortcodes}>
        <div className={classnames('layout', className)} id="layout">
          {children}
        </div>
      </MDXProvider>
      <Footer />
    </>
  );
}
